import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import PaliacateLoader from './PaliacateLoader';

export default function NavigationLoader({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [prevPath, setPrevPath] = useState(location.pathname);

  const handleRouteChange = useCallback(() => {
    if (location.pathname !== prevPath) {
      // Only show loader for admin route transitions
      const isAdminNav = location.pathname.startsWith('/admin') || prevPath.startsWith('/admin');
      if (isAdminNav) {
        setLoading(true);
        const timer = setTimeout(() => setLoading(false), 600);
        return () => clearTimeout(timer);
      }
      setPrevPath(location.pathname);
    }
  }, [location.pathname, prevPath]);

  useEffect(() => {
    const cleanup = handleRouteChange();
    setPrevPath(location.pathname);
    return cleanup;
  }, [location.pathname]);

  // Also listen for when page is fully loaded
  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => setLoading(false), 800);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  return (
    <>
      {loading && <PaliacateLoader />}
      {children}
    </>
  );
}
